import { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const API_URL_AUTH = process.env.REACT_APP_AUTH_URL;

const Header = () => {
  const [dataCounts, setDataCounts] = useState({
    users: 0,
    devices: 0,
    copies: 0,
    bots: 0,
  });

  const fetchCounts = async () => {
    try {
      const devicesResponse = await axios.get(`${API_URL}/devices`);
      const copiesResponse = await axios.get(`${API_URL}/copies`);
      const usersResponse = await axios.get(`${API_URL_AUTH}/users`);

      // Contando quantos devices estão com status "ativo"
      const activeBotsCount = devicesResponse.data.filter(device => device.status === "Ativo").length;

      setDataCounts({
        users: usersResponse.data.length,
        devices: devicesResponse.data.length,
        copies: copiesResponse.data.length,
        bots: activeBotsCount,
      });
    } catch (error) {
      console.error("Erro ao buscar contagem de dados:", error);
    }
  };

  useEffect(() => {
    fetchCounts();
  }, []);

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <Row>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                          Usuários
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {dataCounts.users}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                          <i className="fas fa-users" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      Total de usuários cadastrados
                    </p>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                          Dispositivos
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {dataCounts.devices}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                          <i className="fas fa-mobile-alt" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      Dispositivos cadastrados
                    </p>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                          Copies
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {dataCounts.copies}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i className="fas fa-copy" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      Copies disponíveis no sistema
                    </p>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                          Bots Ativos
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {dataCounts.bots}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i className="fas fa-robot" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      Bots ativos no sistema
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
